// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1TF_w","consentsList":"PatientConsents_consentsList__QZKdQ","consentsListEmpty":"PatientConsents_consentsListEmpty__D1K6M"};